// Main JS entry point.
// Importing the stylesheet here lets webpack extract it to build/css/main.css
// via MiniCssExtractPlugin, so you only need one entry point to manage.
import '../scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
	// eslint-disable-next-line no-console
	console.log('Custom Theme JS loaded');

	// Smooth scrolling itself is CSS (scroll-behavior on html). This feeds the
	// fixed header's height to scroll-padding-top so anchor targets aren't
	// hidden under it; observed because it changes between desktop and mobile.
	const header = document.querySelector('#master-header');

	if (header) {
		const setHeaderHeight = () => {
			document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
		};
		setHeaderHeight();
		new ResizeObserver(setHeaderHeight).observe(header);
	}

	// Skip links: move keyboard focus to the target as well as scrolling to
	// it, so the next Tab continues from the content rather than the header.
	document.querySelectorAll('.skip-link[href^="#"]').forEach((link) => {
		const target = document.querySelector(link.getAttribute('href'));

		if (!target) {
			return;
		}

		if (!target.hasAttribute('tabindex')) {
			target.setAttribute('tabindex', '-1');
		}

		link.addEventListener('click', () => {
			// preventScroll: the browser's own (smooth) anchor scroll handles it.
			target.focus({ preventScroll: true });
		});
	});

	// Mobile nav toggle
	const navToggle = document.querySelector('#site-navigation .menu-toggle');
	const nav = document.querySelector('#site-navigation');

	if (navToggle && nav) {
		navToggle.addEventListener('click', () => {
			nav.classList.toggle('is-open');
			const expanded = navToggle.getAttribute('aria-expanded') === 'true';
			navToggle.setAttribute('aria-expanded', String(!expanded));
		});
	}

	// Mobile nav accordions: tapping a first-level parent's label opens its
	// children and closes any other open parent.
	const mobileParents = document.querySelectorAll('.main-nav-mobile-navigation > .first-level-mobile.has-child');

	const setExpanded = (item, open) => {
		const label = item.querySelector(':scope > p');
		const panel = item.querySelector(':scope > .top-level-sub-nav-container');

		item.classList.toggle('is-expanded', open);
		label.setAttribute('aria-expanded', String(open));
		// Animate to the panel's real height, since its content length varies.
		panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
	};

	mobileParents.forEach((item) => {
		const label = item.querySelector(':scope > p');
		const panel = item.querySelector(':scope > .top-level-sub-nav-container');

		if (!label || !panel) {
			return;
		}

		label.setAttribute('role', 'button');
		label.setAttribute('tabindex', '0');
		label.setAttribute('aria-expanded', 'false');

		const toggle = () => {
			const open = !item.classList.contains('is-expanded');

			mobileParents.forEach((other) => {
				if (other !== item && other.classList.contains('is-expanded')) {
					setExpanded(other, false);
				}
			});

			setExpanded(item, open);
		};

		label.addEventListener('click', toggle);
		label.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				toggle();
			}
		});
	});
});
